import axios from "../../components/shared/axios"
import { actions } from "../admin_templates"

const deleteTemplate = async (state, dispatch) => {
  const id = state.templateToDelete.id
  const url = `${state.basepath}/${id}.json`
  await axios.delete(url)
  dispatch({ type: actions.TEMPLATE_DELETED, payload: id })
}

const toggleActive = async (state, action, dispatch) => {
  const id = action.payload.id
  const url = `${state.basepath}/${id}/${action.payload.active ? 'activate' : 'deactivate'}.json`
  const response = await axios.patch(url)
  dispatch({ type: actions.SET_TEMPLATE_ACTIVE, payload: response.data.template.data })
}

export { deleteTemplate, toggleActive }
